export default __webpack_public_path__ + "static/fox-search-small-3122ba2c4d289f0358f0b2a9ccae30e0.png";